import { render, staticRenderFns } from "./academy_events.vue?vue&type=template&id=83d7120e&"
import script from "./academy_events.vue?vue&type=script&lang=js&"
export * from "./academy_events.vue?vue&type=script&lang=js&"
import style0 from "./academy_events.vue?vue&type=style&index=0&id=83d7120e&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderDefault: require('/home/smiley/3df/components/Header/HeaderDefault/HeaderDefault.vue').default,BlockImageEvents: require('/home/smiley/3df/components/Block/BlockImage/BlockImageEvents.vue').default,BlockPromoEvent: require('/home/smiley/3df/components/Block/BlockPromoEvent/BlockPromoEvent.vue').default,Gallery: require('/home/smiley/3df/components/Gallery/Gallery.vue').default,AcademySectionRegister: require('/home/smiley/3df/components/AcademySectionRegister/AcademySectionRegister.vue').default})
